/**
 * A wrapper for console.log(...) that does not execute in production
 */
function log(...args: any[]): void {
  if (process.env.NODE_ENV !== 'production') {
    console.log(...args)
  }
}

/**
 * A wrapper for console.erro(...) that does not execute in production
 */
function error(...args: any[]): void {
  if (process.env.NODE_ENV !== 'production') {
    console.error(...args)
  }
}

/**
 * A wrapper for console.warn(...) that does not execute in production
 */
function warn(...args: any[]): void {
  if (process.env.NODE_ENV !== 'production') {
    console.warn(...args)
  }
}

/**
 * A wrapper for console.info(...) that does not execute in production
 */
function info(...args: any[]): void {
  if (process.env.NODE_ENV !== 'production') {
    console.info(...args)
  }
}

export default { log, error, warn, info }
